// extracted by mini-css-extract-plugin
module.exports = {"container":"Partner_container__11-ZU","partner-text":"Partner_partner-text__nYJ16","partner-imgs":"Partner_partner-imgs__15Jz8"};